import { createBrowserClient } from "@supabase/ssr";

let browserSupabase: ReturnType<typeof createBrowserClient> | null = null;

export const createClient = () => {
  // In the browser we keep one singleton to avoid re-parsing the bundle & duplicating listeners
  if (typeof window !== "undefined") {
    if (!browserSupabase) {
      browserSupabase = createBrowserClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      );
    }
    return browserSupabase;
  }

  // On the server (RSC) we still create a fresh isolated client per call
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}; 